(function(){
    'use strict';
    angular.module('Services').service('JobDetailsMapService', JobDetailsMapService);

    JobDetailsMapService.$inject = [];

    function JobDetailsMapService() {
        return function(job){
            let mapData = {
                config: {
                    mapId: 'jobDetailsMapView',
                    resetView: true,
                },
                mapControls: [
                ],
                locationData: [{
                    latitude: job.destinationAddress.latitude,
                    longitude: job.destinationAddress.longitude
                }, {
                    latitude: job.sourceAddress.latitude,
                    longitude: job.sourceAddress.longitude
                }],
                mapCenter: {
                    position: {"lat":job.destinationAddress.latitude, "lng":job.destinationAddress.longitude},
                    icon: '',
                    label: 'W'
                },
                loading: false,
                polyLineStart: null,
            };
            this.mapData = mapData;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/maps/jobDetailsMapService.js